import { createSelector } from 'reselect';
import { getLaborTicketSplitDraft } from './getLaborTicketSplitDraft';
import { getEmbeddedLaborTicket } from './getEmbeddedLaborTicket';
import { getCurrentLaborTicket } from './getLaborTickets';

/**
 * Whether the split form can reopen after the job picker. LaborTicketWrapper
 * renders nothing without a ticket, so reopening with none leaves an invisible
 * modal that also hides the clock-out embed. Whether the draft belongs to this
 * ticket is the form's call (isDraftForTicket), since tickets here carry no
 * work order operation ref.
 */
export const getCanResumeSplitDraft = createSelector(
  [getLaborTicketSplitDraft, getEmbeddedLaborTicket, getCurrentLaborTicket],
  (splitDraft, embeddedLaborTicket, currentLaborTicket) => {
    return Boolean(
      splitDraft?.splitTime && (embeddedLaborTicket || currentLaborTicket)
    );
  }
);
